module.exports = __webpack_public_path__ + "img/bg.980bc9b8.png";